import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ChannelTemplate } from "../../../../domain/channel-template";

@Component({
  selector: "templates-window",
  templateUrl: "./templates-window.component.html",
  styleUrls: ["./templates-window.component.scss"],
})
export class ChooseTemplateTemplatesWindowComponent {
  @Input()
  templates: Array<ChannelTemplate>;

  @Output()
  onTemplateClicked: EventEmitter<ChannelTemplate> =
    new EventEmitter<ChannelTemplate>();

  constructor() {}
}
